import React from 'react'
import { Navigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Loader2 } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'
import { clearAuthSession } from '@/lib/authToken'

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const segment = parts[1]
    if (!segment) return null
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    return JSON.parse(atob(padded)) as Record<string, unknown>
  } catch {
    return null
  }
}

function isTokenValid(token: string): boolean {
  const payload = decodeJwtPayload(token)
  if (!payload || payload.platformRole !== 'super_admin') return false
  // Check expiry — JWT exp is in seconds
  if (typeof payload.exp === 'number' && payload.exp * 1000 < Date.now()) return false
  return true
}

interface Props {
  children: React.ReactNode
}

const AdminProtectedRoute: React.FC<Props> = ({ children }) => {
  const { currentTheme } = useTheme()
  const token = Cookies.get('token')

  if (!token || !isTokenValid(token)) {
    clearAuthSession()
    return <Navigate to="/admin/login" replace />
  }

  if (!children) {
    return (
      <div
        className="h-screen flex items-center justify-center"
        style={{ backgroundColor: currentTheme.primary }}
      >
        <Loader2 size={32} className="animate-spin" style={{ color: currentTheme.accent }} />
      </div>
    )
  }

  return <>{children}</>
}

export default AdminProtectedRoute
